import moment from 'moment';
import React from 'react';
import styled from 'styled-components';

const EventItem: React.FunctionComponent<{ item: any }> = ({ item }) => {
  const text = item.getIn(['message', 'text']);

  return (
    <OuterContainer>
      <Border signal={1} />
      <EventItemContainer>
        <Message>
          <ModelContainer>
            <Side signal={1}>{text}</Side>
          </ModelContainer>
          <DateContainer>
            {/* Start Time */}
            <Date>{moment(item.get('start_time')).format('MM-DD-YYYY')}</Date>
            <Time>{moment(item.get('start_time')).format('HH:mm:ss')}</Time>
            {/* Stop Time */}
            <Date>{moment(item.get('stop_time')).format('MM-DD-YYYY')}</Date>
            <Time>{moment(item.get('stop_time')).format('HH:mm:ss')}</Time>
          </DateContainer>
        </Message>
      </EventItemContainer>
    </OuterContainer>
  );
};

const Date = styled.span`
  color: ${({ theme }) => theme.core.textColor};
  font-size: 10px;
  margin-right: 4px;
`;

const ModelContainer = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  white-space: nowrap;
`;

const DateContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  text-align: end;
  margin-left: 7.5px;
  white-space: nowrap;
`;

const Time = styled(Date)`
  margin: 0;
`;

const Side = styled.span<{ signal: number}>`
  color: ${({ theme, signal }) => {
    if (signal > 0) {
      return theme.template.green.dark;
    } else if (signal > -2) {
      return theme.template.red.dark;
    } else {
      return theme.template.blue.dark;
    }
  }};
  padding: 0 2px 0 7.2px;
`;

const EventItemContainer = styled.div`
  margin-bottom: 4px;
  color: ${({ theme }) => theme.core.textColor};
  border-radius: 3px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  z-index: 1;
  font-size: 12px;
  padding: 7px;
  width: 100%;
  background-color: ${({ theme }) => theme.core.darkBackground};
`;

const Message = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  padding-right: 12px;
  justify-content: space-between;
  align-items: center;

  ${Side} {
    margin-right: 2px;
  }
`;

const Border = styled.div<{ signal: number}>`
  border-radius: 2.5px;
  height: inherit;
  margin-bottom: 4px;
  width: 4.8px;
  background-color: ${({ theme, signal }) => {
    if (signal > 0) {
      return theme.template.green.dark;
    } else if (signal > -2) {
      return theme.template.red.dark;
    } else {
      return theme.template.blue.dark;
    }
  }};
`;

const OuterContainer = styled.div`
  display: grid;
  justify-content: space-between;
  grid-template-columns: auto 1fr;
  width: 100%;
`;

export default EventItem;
